import classnames from 'classnames'
import { useRouter } from 'next/router'
import React from 'react'
import { useTranslate } from 'react-polyglot'

import Slider from '@unlikelystudio/react-slider'

import ArticleBig from '~/components/ArticleBig'
import CurveComponent from '~/components/CurveComponent'
import HeroEdito from '~/components/HeroEdito'
import Link from '~/components/Link'
import Pagination from '~/components/Pagination'

import { useTheme } from '~/providers/ThemeProvider'

import useLocale from '~/hooks/useLocale'

import getBlogPageServerSidePropsFunction from '~/data/blog-page'

import css from './styles.module.scss'

const cx = classnames.bind(css)

function Blog({ slices, blogPage, blogArticles, blogPagination }) {
  const { title, text, categories } = blogPage || {}
  const t = useTranslate()
  const locale = useLocale()
  const router = useRouter()

  const category = router?.query?.category
  const page = router?.query?.page

  const { colors } = useTheme()

  const filters = [
    // <Link
    //   className={cx(css.filter, { [css.current]: !category })}
    //   href="/blog"
    //   key={`filter_nothing`}
    //   locale={locale}>
    //   {t('categories.edito')}
    // </Link>,
    <Link
      className={cx(css.filter, {
        [css.current]: category === 'all' || !category,
      })}
      href="/blog?category=all"
      key={`filter_all`}
      locale={locale}>
      {t('categories.all')}
    </Link>,
    categories?.map((item, index) => (
      <Link
        className={cx(css.filter, {
          [css.current]: category === item.uid,
        })}
        href={`/blog?category=${item.uid}`}
        key={`filter${index}`}
        locale={locale}>
        {item.name}
      </Link>
    )),
  ]

  return (
    <div className={css.BlogPage}>
      <HeroEdito className={css.heroEdito} title={title} text={text}>
        <div className={cx(css.filters)}>
          <Slider className={css.slider}>{filters}</Slider>
        </div>
      </HeroEdito>

      <CurveComponent className={css.curve} />

      <div className={css.blogContent}>
        {/* {blogArticles?.length === 0 && (
          <SliceManager
            mapSliceTypeToComponent={mapSliceTypeToComponent}
            slicesData={slices}
          />
        )} */}

        {blogArticles?.map((article, index) => (
          <ArticleBig
            className={css.article}
            article={article}
            key={`article_lines${index}`}
          />
        ))}

        {blogArticles?.length > 0 && (
          <div className={css.pagination}>
            <Pagination {...blogPagination} />
          </div>
        )}
      </div>
    </div>
  )
}

export default Blog

export const getServerSideProps = getBlogPageServerSidePropsFunction()
